import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ap-page-title',
    templateUrl: './page-title.component.html',
    styleUrls: ['./page-title.component.css'],
    standalone: false
})
export class PageTitleComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
